import { render, staticRenderFns } from "./OrderCourse.vue?vue&type=template&id=4c9b6196&"
import script from "./OrderCourse.vue?vue&type=script&lang=js&"
export * from "./OrderCourse.vue?vue&type=script&lang=js&"
import style0 from "./OrderCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports